let serverTimeOffset = 0

export const getServerTimeOffset = () => serverTimeOffset
export const setServerTimeOffset = (serverTime) => serverTimeOffset = Date.now() - serverTime

export const getServerTime = (when: number = undefined) => (when || Date.now()) - serverTimeOffset
export default getServerTime
